import {useEffect} from 'react';
import {Container} from '@mui/material';
import {useDispatch} from 'react-redux';
import {routeStateActions} from '@app/router/redux';
import {navbarComponentName} from '@app/router/redux/routeHandler';
import {strings} from '@app/common/strings';
import {useStyles} from './styles';
import {NDSAuditDetailsScreen} from './NDSAuditDetailsScreen';

export const NDSAuditDetails = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(
      routeStateActions.setNavbarComponentName(
        navbarComponentName.NDSAuditDetails,
      ),
    );
    dispatch(
      routeStateActions.setNavbarComponentHeading(
        <div className={classes.navbarComponentHeading}>
          {strings.NDSAuditDetails}
        </div>,
      ),
    );
    return () => {
      dispatch(routeStateActions.setNavbarComponentName(''));
      dispatch(routeStateActions.setNavbarComponentHeading(<></>));
    };
  }, []);

  return (
    <Container maxWidth={false}>
      <NDSAuditDetailsScreen />
    </Container>
  );
};

export default NDSAuditDetails;
